import { render, staticRenderFns } from "./GroupListPopup.vue?vue&type=template&id=096c807a&scoped=true&"
import script from "./GroupListPopup.vue?vue&type=script&lang=ts&"
export * from "./GroupListPopup.vue?vue&type=script&lang=ts&"
import style0 from "./GroupListPopup.vue?vue&type=style&index=0&id=096c807a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096c807a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VImg,VList,VListItem,VListItemContent})
